import moment from "moment/moment";
import React, {useContext, useEffect, useState} from 'react';

import {Link, useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import {ReactComponent as CloseBtn} from '../../../assets/icons/close.svg';
import OtpSpace from "../../../assets/icons/otp-space.png";
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import Popup from '../../../components/Popup';
import init from '../AccessControl/Check';
import $ from 'jquery';
import DynamicButton from "../../../components/DynamicButton";
import AcceptIcon from "../../../components/Svg/accept";
import RejectIcon from "../../../components/Svg/reject";
import ShippedIcon from "../../../components/Svg/shipped";
import DeliveredIcon from "../../../components/Svg/delivered";
import {MailIcon, ShowVerificationCodeIcon} from "../../../components/Svg/mail";

import UserBasicInfoContext from "../../../components/Context/UserBasicInfoContext";
import { SUPER_ADMIN_CODE } from './../ConstRole/ConstRole';
import DownloadInvoice from "../../../components/Pdf/DownloadInvoice";
import { pdf } from "@react-pdf/renderer";
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";


const OrderInvoice = (category) => {

    const pageName = "Order Invoice";
    const isAccess = init(pageName);

    const userProfile = useContext(UserBasicInfoContext);
    const companyProfile = useContext(UserBasicInfoQRContext);

    const {id} = useParams();
    const [orderDetails, setOrderDetails] = useState();
    const [orderItemDetails, setOrderItemDetails] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [isRefresh, setIsRefresh] = useState(0);

    // CODE RELATED INFO
    const [show, setShow] = useState(false);
    useEffect(() => {
        if (show === false) {
            return;
        }

        setTimeout(() => {
            setShow(false);
        }, 5000);
    }, [show]);


    // Check PIN
    const checkPIN = () => {
        if ($("#voucherPIN")?.val() === process.env.REACT_APP_SHOW_ITEM_CODE) {
            setShow(true);
            toast.success("This voucher code stay for 5 seconds");
        }
        else {
            toast.error("You have entered an invalid PIN");
        }
    };


    const [popUpData, setPopUpData] = useState({});
    const [isTermsShow, setIsTermsShow] = useState(false);
    const closeModel = () => {
        setIsTermsShow(false);
        setPopUpData({});
    }


    const openModel = (data) => {
        setPopUpData({
            ...popUpData,
            bookingId: data?.booking_id ?? "",
            code: atob(data?.code) ?? ""
        });

        setIsTermsShow(true);
    }


    // Order Details 
    useEffect(() => {
        try {
            PostLoginGetApi(`order/logs/${id}`, "", 2).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        setIsLoad(true);
                        setOrderDetails(responseData.data.details);
                        setOrderItemDetails(responseData.data.details.item_details);
                    }
                }

            }).catch((err) => {
                console.log(err);
            });
        } catch (ex) {
            console.log(ex);
        }
    }, [isRefresh])

    const handleOrderAcceptedOrCancelled = (value) => {
        // Call Request for order accept or cancelled
        PostLoginPostApi(`order/${id}/status-accepted-or-cancelled`, JSON.stringify({status: value})).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response['status'] === 1) {
                let responseData = JSON.stringify(response['data']);
                responseData = JSON.parse(responseData);

                if (responseData['code'] === 200) {
                    setIsRefresh((prevCounter) => {
                        return prevCounter + 1;
                    });
                    // navigate('/dashboard/store')
                }
            }
        }).catch(err => {
            console.log(err);
        })
    }

    const [reqParam, setReqParam] = useState({});
    const [statusModal, setStatusModal] = useState({
        isShow: false,
        id: ""
    });

    const handleOrderBookingStatus = (id, value) => {
        PostLoginPostApi(`item/${id}/booking-status/v2/${value}`, JSON.stringify(reqParam)).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);
            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData['code'] === 200) {
                    toast.success(responseData['messages']?.toString() ?? "Item status update successfully.");

                    setReqParam({...reqParam, remarks: ""}); // clear remarks input after submit
                    setStatusModal(false);
                    setIsRefresh((prevCounter) => {
                        return prevCounter + 1;
                    });

                    return;
                }

                setStatusModal(false);
                toast.error(responseData['messages']?.toString() ?? "A problem occur. Please try again.");
                return;

            }
        }).catch((err) => {
            console.log(err);
        });
    }

    
    // Verify Order / Resend Email
    const handleOnlineOrderVerify = () => {
        PostLoginPostApi(`order/${id}/verify-online-type`).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response['status'] === 1) {
                let responseData = JSON.stringify(response['data']);
                responseData = JSON.parse(responseData);

                if (responseData['code'] === 200) {
                    toast.success("Order verified and code send successful via email.");
                    setStatusModal(false);
                    
                    setIsRefresh((prevCounter) => {
                        return prevCounter + 1;
                    });

                    return;
                } 

                setStatusModal(false);
                toast.error(responseData['messages']);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    

    const renderOrderInvoiceBigButton = (data) => {
        if(  data.bookingStatus?.length === 0 ) {
            return;
        }

        if( orderDetails?.delivery_type === "Online" ) {
            return;
        }

        if( data.bookingStatus === "Canceled" ) {
            return;
        }

        if( orderDetails?.payment_status !== 'Paid' ) {
            return;
        }



        if (data.bookingStatus === "Pending" ) {
            return (<>
                    <DynamicButton name={'Accepted'}
                                onClick={() => setStatusModal({
                                    isShow: true,
                                    id: orderDetails?.id,
                                    status: "Accepted"
                                })}
                                type={'Button'}
                                color={'blue'}
                                icon={<AcceptIcon/>}
                                id={"Accepted"}
                    >
                    </DynamicButton>
                    <DynamicButton name={'Rejected'}
                                onClick={() => setStatusModal({
                                    isShow: true,
                                    id: orderDetails?.id,
                                    status: "Rejected"
                                })}
                                type={'Button'}
                                color={'red'}
                                icon={<RejectIcon/>}
                                id={"Rejected"}
                    >
                    </DynamicButton>
                </>
            )
        }
        else if(data.bookingStatus === "Accepted") {
            return (
                <DynamicButton 
                    name={'Shipped'}
                    onClick={() => setStatusModal({isShow: true, id: orderDetails?.id, status: "Shipped"})}
                    type={'Button'}
                    id={'shipped-btn'}
                    color={'red'}
                    icon={<ShippedIcon/>}
                >
                </DynamicButton>
            )
        }
        else if(data.bookingStatus === "Shipped") {
            return (
                <DynamicButton 
                    name={'Delivered'}
                    onClick={() => setStatusModal({isShow: true, id: orderDetails?.id, status: "Delivered"})}
                    type={'Button'}
                    id={'delivered-btn'}
                    color={'green'}
                    icon={<DeliveredIcon/>}
                >
                </DynamicButton>
            )
        }

    }
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [editInstruction, setEditInstruction] = useState({
        VerifyOtp2: false,
    });


    const closeInstructionModel = (value = "") => {
        if (value === "otp") {
            setOtp(new Array(6).fill(""));
            setEditInstruction({VerifyOtp2: false});
        } else {
            setEditInstruction({VerifyOtp2: false});
        }
    }


    const handleChange = (element, index, value) => {
        if (isNaN(element.value)) {
            return false;
        }

        if (value === "otp") {
            setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
        }


        if (element.value !== "" && element.parentNode.nextSibling) {
            element.parentNode.nextSibling.querySelector("input").focus();
        }

        if (element.value === "" && element.parentNode.previousSibling) {
            element.parentNode.previousSibling.querySelector("input").focus();
        }
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                <tr>
                    <td className="font-semibold text-base">
                        You do not have any access !
                    </td>
                </tr>
                </tbody>
            </table>
        </>);
    }

    const closePage = () => {
        const url = window.location.href;
        if (url.includes("source=settlement")) {
            document.location.href = "/dashboard/settlement";
            return;
        }

        document.location.href = "/dashboard/orders";
        return;
    }


    const downloadInvoice = async () => {
        const blob = await pdf(<DownloadInvoice prop={orderDetails} orderItemDetails={orderItemDetails} companyInfo={companyProfile} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice_${orderDetails?.order_unique_id}.pdf`;
        link.click();
        URL.revokeObjectURL(url); // clean up
    }

    return (
        <>
            {isLoad === true &&
                <div className="h-full">
                    <header className="flex justify-between fixed w-full z-[999] bg-white h-16  items-center p-4 border-b-2 border-dark-white">
                        <Link onClick={closePage}>
                            <CloseBtn className="float-left"/>
                        </Link>
                        <p className="text-xl text-black">Order Details</p>
                        <div>
                            <button className="w-full bg-[#158560] text-white hover:opacity-[.9] rounded-[3px] cursor-pointer px-4 py-1 font-semibold" onClick={downloadInvoice}>
                                Download
                            </button>
                        </div>
                    </header>
                        
                    <main className="max-w-2xl m-auto py-[60px] pt-[100px]">
                        <div className='flex items-center justify-between'>
                            <div className='mb-7'>
                                <p className='text-lg text-[#222222]'>Bill To
                                    <span className='pl-1 font-semibold'>{orderDetails?.shipping_co || orderDetails?.customer_info.customer_name || ''}</span>
                                </p>
                                <p className='mt-1 opacity-90'>{orderDetails?.customer_info.customer_email}</p>
                                <p className='opacity-90'>{orderDetails?.shipping_phone || orderDetails?.customer_info.customer_mobile || ''}</p>
                            </div>
                            <div>
                                <p className="text-ash mb-1 text-sm text-right">Created At</p>
                                <p className="text-end text-sm">{moment(orderDetails?.created_at).format('LLL')}</p>
                            </div>
                        </div>

                        <div className=' flex justify-between mb-7'>
                            <div>
                                <p className='text-sm text-[#444444] mb-[2.5]'>Order No.</p>
                                <p className='text-[#8B8F97] font-semibold pt-1'>{orderDetails?.order_unique_id}</p>
                            </div>

                            <div>
                                <p className='text-ash mb-1 text-sm text-right'>Updated At</p>
                                <p className='text-end text-sm'>{moment(orderDetails?.updated_at).format('LLL')}</p>
                            </div>

                        </div>

                        <div className='mb-7'>
                            <p className='text-sm text-[#444444] mb-[2.5]'>Order Type</p>
                            <p className='text-[#222222]'>{orderDetails?.delivery_type}</p>
                        </div>

                        {/* 
                        {(orderDetails?.billing_address !== "") &&
                            <div className='mb-3'>
                                <p className='text-sm text-[#444444] mb-[2.5]'>Billing Address</p>
                                <p className='text-[#222222]'>{orderDetails?.billing_address ?? "-"}</p>
                            </div>
                        } */}

                        {(orderDetails?.shipping_address !== "") &&
                            <div className='mb-7'>
                                <p className='text-[#444444] mb-[2.5]'>
                                    Ship To
                                    <span className='pl-1 font-semibold'>{orderDetails?.shipping_co || ''}</span>
                                </p>
                                <p className='text-[#222222] ' style={{marginTop: "5px"}}>
                                    {(orderDetails?.delivery_type === "Online") ? "Online" : 
                                        <>{orderDetails?.shipping_address ?? "-"}</>
                                    }
                                </p>
                            </div>
                        }


                        <div className='p-5 rounded-md flex justify-between mb-2.5 w-full items-center'
                            style={{background: "rgba(250, 168, 25, 0.1)"}}>

                            <div>
                                <p className='text-lg text-[#444444]'>Payment Status</p>
                            </div>
                            <div className='text-end'>
                                <p className='text-xl float-right text-[#222222] font-semibold'>
                                    {orderDetails?.payment_status}
                                    {(orderDetails?.payment_status === "Refunded" && orderDetails?.refund_remarks?.length > 0) &&
                                        <span
                                            className="block font-normal text-sm">({orderDetails?.refund_remarks})</span>
                                    }
                                </p>
                            </div>
                        </div>


                        <div className='p-5 rounded-md flex justify-between  bg-[#E8F7EC]'>
                            <div>
                                <p className='text-[#444444] mb-2.5'>Total Amount</p>
                                <p className='text-xl text-[#222222]'>{process.env.REACT_APP_CURRENCY_SYMBOL} {orderDetails?.payable_amount}</p>
                            </div>
                            <div className='text-end'>
                                <p className='text-[#444444] mb-2 text-right pr-1'>Order Status</p>
                                <div className='py-[3px] px-5 bg-[#FAA819] rounded-[16px] font-semibold text-white'>
                                    <p>{orderDetails?.status}</p>
                                </div>
                            </div>

                            {/*<div className='text-end'>
                                <p className='text-[#444444] mb-1 text-right pr-1'>Payment Method</p>
                                <div className='text-sm py-[5px] inline-block px-5 bg-[#03A629] rounded-[18px] text-white'>
                                    <p>{orderDetails?.payment_methods}</p>
                                </div>
                            </div>*/}
                        </div>

                        <h3 className='text-xl my-[30px] text-[#222222]'>Item/Service Details</h3>

                        <div className='mb-[30px]'>
                            {orderItemDetails.map((data, index) => (
                                <div key={index}>
                                    <div className='flex justify-between items-center mb-[15px]'>
                                        <div className='w-full'>
                                            <div className="w-4/5 float-left">
                                                <p className='text-[#222222] mb-1'>{data.quantity} x {data.name}</p>
                                                {data.addons?.map((data2, index2) => (
                                                    <span key={index2}>
                                                        <div className="flex">
                                                            <li className='text-[#444444] text-sm'>{data2.name}</li>
                                                            <span className='mx-1'>(</span>
                                                            {data2?.items?.map((data3, index3) => (
                                                                <p key={index3} className='text-[#444444] text-sm'>
                                                                    {data3.name} 
                                                                    {(data2.items.length - 1 > index3) && ","}&nbsp;
                                                                </p>
                                                            ))}
                                                            <span>)</span>
                                                        </div>
                                                    </span>
                                                ))}
                                            </div>
                                            

                                            <p className="w-1/5 float-right text-right">{process.env.REACT_APP_CURRENCY_SYMBOL} {data.unitPrice}</p>
                                            
                                            {data.addons?.map((data2, index2) => (
                                                <span key={index2}>
                                                {data2?.items?.map((data3, index3) => (
                                                    <p key={index3} className="w-1/5 float-right text-right text-[#444444] text-sm" style={{paddingTop: "5px"}}>
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL} {data3.unit_price}
                                                    </p>
                                                ))}
                                                </span>
                                            ))}

                                            <div className="w-4/5 float-left -ml-2 mt-2">
                                                {renderOrderInvoiceBigButton(data)}
                                                {(orderDetails?.delivery_type === "Online" && orderDetails?.payment_status === "Paid") &&
                                                    <>
                                                    <DynamicButton name={'Verify/Resend Email'}
                                                                onClick={() => setStatusModal({
                                                                    isShow: true,
                                                                    id: data.id,
                                                                    status: "Resend"
                                                                })}
                                                                type={'Button'}
                                                                color={'orange'}
                                                                icon={<MailIcon/>}
                                                    >
                                                    </DynamicButton>
                                                    
                                                    <> 
                                                    {(orderDetails?.delivery_type === "Online" && orderDetails?.payment_status === "Paid" && orderDetails?.status === "Completed" && userProfile?.user_type_id === SUPER_ADMIN_CODE) &&

                                                        <DynamicButton name={'Verify/Show Code'}
                                                                onClick={() => openModel({
                                                                    booking_id: orderDetails?.order_unique_id,
                                                                    code: orderDetails?.item_secret ?? ""
                                                                })}
                                                                type={'Button'}
                                                                color={'green'}
                                                                icon={<ShowVerificationCodeIcon />}
                                                        >
                                                        </DynamicButton>
                                                    
                                                }</>

                                                    
                                                    </>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                            <hr className='my-5 bg-[#DDDDDD]'/>

                            <div className='flex justify-end text-[#222222] space-x-36'>
                                <div className='flex flex-col space-y-3'>
                                    {(orderDetails?.applied_coupon) && <p>Applied Coupon</p>}
                                    <p>Subtotal</p>
                                    <p>Discount (-)</p>
                                    {/*<p>Convenience Fee (+)</p>*/}
                                </div>
                                <div className='flex flex-col space-y-3 text-right'>
                                    {(orderDetails?.applied_coupon) && <p className="font-semibold">{orderDetails?.applied_coupon ?? ""}</p>}
                                    <p>{process.env.REACT_APP_CURRENCY_SYMBOL} {orderDetails?.amount}</p>
                                    <p>{process.env.REACT_APP_CURRENCY_SYMBOL} {orderDetails?.discount_amount}</p>
                                    {/*<p>{process.env.REACT_APP_CURRENCY_SYMBOL} {orderDetails?.convenience_fee ?? 0}</p>*/}
                                </div>
                            </div>
                        </div>

                        {(orderDetails?.customer_note) &&
                            <>
                                <h3 className='text-lg mt-10 mb-1.5 text-[#222222]'>Note</h3>
                                <p className='text-[#55585B] text-sm leading-[22px] mb-[20px]'>
                                    {/* Mobile invoicing is an easy way to bill your clients right from your mobile device so they can pay you quickly and securely. Now you can send and manage electronic invoices on your device for Free */}
                                    {orderDetails?.customer_note}
                                </p>
                            </>
                        }
                        
                        {(orderDetails?.remarks && orderDetails?.remarks.trim() !== "") &&
                            <>
                                <h3 className='text-lg mt-10 mb-1 text-[#222222]'>Reject Remarks</h3>
                                <p className='text-[#55585B] text-sm leading-[22px] mb-[30px]'>
                                    {/* Mobile invoicing is an easy way to bill your clients right from your mobile device so they can pay you quickly and securely. Now you can send and manage electronic invoices on your device for Free */}
                                    {orderDetails?.remarks}
                                </p>
                            </>
                        }


                    </main>

                    {/* VERIFY OTP POPUP */}

                    {
                        (() => {
                            if (editInstruction.VerifyOtp2 === true) {
                                return (
                                    <>
                                        <Popup content={

                                            <div className="w-[470px] py-10 px-5 font-medium ">
                                                <div className="flex justify-between">
                                                    <h1 className='font-semibold leading-5 text-xl text-[#222222]'>Verify
                                                        OTP</h1>
                                                    <CloseBtn className="cursor-pointer" onClick={() => closeInstructionModel("otp")}/>
                                                </div>
                                                <p className='text-sm font-normal leading-5 my-5'>Please enter the
                                                    6-digit code we’ve sent to {orderDetails?.user_mobile} and consumer’s
                                                    order invoice</p>

                                                <div className="flex items-center space-x-2 w-full container mb-5">
                                                    {otp.map((data, index) => {
                                                        return (
                                                            <span className='flex justify-center items-center' key={index}>
                                                                <input
                                                                    type="text"
                                                                    name="otp[]"
                                                                    maxLength="1"
                                                                    key={index}
                                                                    value={data}
                                                                    className="w-[59px] h-[60px] border border-solid border-[#EEEEEE] rounded-lg text-center"
                                                                    onChange={(e) => {
                                                                        handleChange(e.target, index, "otp");
                                                                    }}
                                                                    onFocus={(e) => e.target.select()}
                                                                    required
                                                                />
                                                                {((index + 1) % 2 === 0 && index < (otp.length - 1)) && (
                                                                    <img alt="OTP Space" src={OtpSpace} className="h-[2px] w-[9px] ml-[10px] mr-0"></img>)}
                                                            </span>
                                                        );
                                                    })}
                                                </div>

                                                <button type="submit" id="otp_submit_btn" className="w-full text-white bg-[#1A202C] py-[12px] px-[32px]  rounded-[3px] cursor-pointer flex justify-center items-center mb-3 leading-6 disabled:bg-gray-500 disabled:cursor-wait">
                                                    Verify OTP
                                                </button>

                                            </div>

                                        }
                                        />
                                    </>
                                )
                            }
                        })()
                    }
                </div>
            }

            
            {/* Model Window */}
            {(isTermsShow === true) &&
                <div>
                    <Popup content={
                        <div className="p-5 font-medium">
                            <div className="flex justify-between">
                                <h3 className="text-xl text-black font-semibold">Order Information</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeModel} />
                            </div>

                            <div className='max-w-lg mt-6 pr-1 whitespace-break-spaces'>
                                <table id="voucher-details-table" className="custom-details-table w-full mt-0 mb-5">
                                    <tbody>
                                        <tr>
                                            <td className="font-semibold text-base w-[180px]">Booking Id</td>
                                            <td className="px-5 text-base">{popUpData?.bookingId}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Booking Status</td>
                                            <td className="px-5 text-base">{orderItemDetails[0]?.bookingStatus ?? "-"}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Payment Status</td>
                                            <td className="px-5 text-base">{orderItemDetails[0]?.paymentStatus ?? "-"}</td>
                                        </tr>
                                        {(userProfile?.user_type_id === SUPER_ADMIN_CODE) &&
                                            <tr>
                                                <td className="font-semibold text-base">Code</td>
                                                <td className="px-3 text-base" style={{background: "white"}}>
                                                    {show ?
                                                        <>{popUpData?.code}</>
                                                        :
                                                        <>
                                                            <input type="password" autoComplete='off' id="voucherPIN" placeholder="PIN" name="voucherPIN" className='w-[150px] mr-1 float-left mt-1 border-none bg-[#F5F5F5] rounded-l' />

                                                            <button type="button" id="show_code_btn" className="btn-xs mt-1 text-white bg-primary p-2 mb-2 rounded cursor-pointer hover:bg-brand-dark button button1" onClick={checkPIN}>
                                                                Show
                                                            </button>
                                                        </>
                                                    }
                                                </td>

                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>}
                    />
                </div>
            }

            {/* Popup */}
            {((statusModal?.isShow === true) && statusModal.id !== "") ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative p-4 w-full max-w-lg h-full md:h-auto">
                            {/*content*/}
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button type="button" onClick={() => setStatusModal(false)}
                                        className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                                        data-modal-toggle="popup-modal">
                                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clipRule="evenodd"></path>
                                    </svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <svg aria-hidden="true"
                                        className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                        {(statusModal.status !== 'Resend') ? (
                                            <span className="text-sm block mb-1">
                                                Are you sure you want to change item status to {statusModal.status}?
                                            </span>
                                        ) : (
                                            <span className="text-sm block mb-1">
                                                Are you sure you want to verify and resend mail?
                                            </span>
                                        )
                                        }
                                    </h3>
                                    {(statusModal.status === 'Rejected') && 
                                        <textarea
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 mb-6 resize-none" rows={5} maxLength={150}
                                            placeholder="Enter remarks (optional)"
                                            value={reqParam?.remarks}
                                            onChange={(e) => setReqParam({...reqParam, remarks: e.target.value})}
                                        />
                                    }
                                    <button data-modal-toggle="popup-modal" type="button"
                                            onClick={() => (statusModal.status !== 'Resend') ? handleOrderBookingStatus(statusModal.id, statusModal.status) : handleOnlineOrderVerify()}
                                            className="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                        Yes, I'm sure
                                    </button>
                                    <button data-modal-toggle="popup-modal" type="button"
                                            onClick={() => setStatusModal(false)}
                                            className="text-white-500 bg-red hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">
                                        No, cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>

    );
};

export default OrderInvoice;
